export const actionTypes = {
  SET_IS_LOADING: 'SCHEDULE_TOUR/SET_IS_LOADING',
  SAVE_TOUR_ACTION_RESULT: 'SCHEDULE_TOUR/SAVE_TOUR_ACTION_RESULT',
  RESET_SAVE_TOUR_ACTION_RESULT: 'SCHEDULE_TOUR/RESET_SAVE_TOUR_ACTION_RESULT',
};
